export default __webpack_public_path__ + "static/media/title_transport.c62650dd.jpg";